import "./stickyNote.scss";
import IconButton from "../iconButton/iconButton";
import RemoveIcon from "../../assets/images/removeNote.svg"
import { toPersianNumber } from "../../utils/toPersianNumber";
export default function StickyNote({ note, onClick, loading }) {
  return (
    <div className="stickyNote">
      <div className="stick flex aline-center">
        <IconButton icon={RemoveIcon} tooltip="پاک کردن" onClick={onClick} loading={loading} />
      </div>
      <div className="note">{toPersianNumber(note)}</div>
    </div>
  );
}
